<template>
    <v-menu
        ref="pickerMenu"
        :close-on-content-click="false"
        v-model="pickerMenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px">
        <v-text-field ref="input"
            slot="activator"
            v-model="formattedValue"
            :label="label"
            prepend-icon="event"
            :hint="label"
            readonly
            :rules="[internalRules]"
        ></v-text-field>
        <v-date-picker 
            :allowed-dates="allowedDates"
            v-model="valueString"
            :first-day-of-week="1"
            @input="pickerMenu = false">
        </v-date-picker>
    </v-menu>
</template>

<script>
import UtilService from '@/services/utilService.js';

export default {
	props: [
        'label',
		'value',
        'allowedDates',
        'rules'
	],
	data(){
		return {
            pickerMenu: false
		};
	},
	computed: {
        valueString: {
            get(){
                return UtilService.formatDateYMD(this.value);
            },
            set(v){
                this.$emit("input", UtilService.parseDateYMD(v));
            }
        },
        formattedValue(){
            return UtilService.formatDateDMY(this.value);
        }
	},
	methods: {
        internalRules(){
            if(this.rules == null){
                return false;
            }

            let result = this.rules
                .map(rule => rule(this.value))
                .find(result => result);

            if(result){
                return result;
            }

            return false;
        },
        validate(){
            this.$refs.input.validate();
        }
	}
}
</script>